import * as React from "react";
import { Link } from "react-router-dom";
import OUStore from "../../../../stores/OUStore";
import { GetOUList } from "../../../../actions/OUActions";
import actionTypes from "../../../../actions/ActionTypes";
class OUSidebar extends React.Component {
  constructor() {
    super();
    this.state = {
      ouList: []
    };
    this.onReceiveOUChange = this.onReceiveOUChange.bind(this);
  }
  componentDidMount() {
    OUStore.addChangeListener(this.onReceiveOUChange);
    GetOUList();
  }
  componentWillUnmount() {
    OUStore.removeChangeListener(this.onReceiveOUChange);
  }
  onReceiveOUChange() {
    let lastChange = OUStore.getLastChange();
    if (lastChange === actionTypes.OUGetList) {
      let ous = OUStore.getOUList();
      this.setState({
        ouList: ous
      });
    }
  }
  render() {
    let listOfOUs;
    if (this.state.ouList !== null) {
      listOfOUs = this.state.ouList.map((ou) => /* @__PURE__ */ React.createElement("div", { key: ou.orgUnitId }, /* @__PURE__ */ React.createElement(
        Link,
        {
          className: "sidebar-link",
          to: "/Admin/OrgUnit/" + ou.orgUnitId,
          style: { cursor: "Pointer", wordWrap: "break-word" }
        },
        ou.name
      ), " "));
    } else {
      listOfOUs = /* @__PURE__ */ React.createElement("div", null);
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "d-flex flex-column p-3 text-white bg-dark",
        style: { height: "100%", width: "300px" }
      },
      /* @__PURE__ */ React.createElement(
        Link,
        {
          to: "/Admin/BusinessProcess",
          className: "d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none"
        },
        /* @__PURE__ */ React.createElement("span", { className: "fs-4" }, /* @__PURE__ */ React.createElement("span", { style: { color: "#EFDA62" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-folder" })), "   ", "Organizational Units")
      ),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement("div", null, listOfOUs),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement(Link, { className: "sidebar-link", to: "/Admin/OrgUnit/0" }, "New Organizational Unit")
    );
  }
}
export default OUSidebar;
